import { Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractComponent, CookieService } from '@shopping-angular-components/common-library';
import { CoachmarkInfoI18n } from './coupon-i18n';
import { version } from './environment';

interface CoachmarkInfo {
  product: string;
  showCount: number;
  lastShownAt: string | null;
}

interface CoachmarkStorage {
  value: CoachmarkInfo[];
}

@Component({
  selector: 'coupon-coachmark',
  templateUrl: './coupon-coachmark.component.html',
  styleUrls: ['./coupon-coachmark.component.scss']
})
export class CouponCoachmarkComponent extends AbstractComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() description: string;  
  @Input() product: string = '';
  @Input() position?: string = '-bottom -right';
  @Input() isActiveDiscountCookieName: string;
  @Output() closeEvent: EventEmitter<boolean> = new EventEmitter();

  private readonly LS_COUPON_COACHMARK = 'coupon-coachmark';

  showTooltip: boolean;
  isCouponActive: boolean;

  constructor(injector: Injector, private cookieService: CookieService) {
    super(injector, CoachmarkInfoI18n.messages, version);
  }

  getComponentName(): string {
    return 'CouponCoachmarkComponent';
  }

  ngOnInit(): void {
    this.init();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  close(event: MouseEvent): void {
    event.stopPropagation();
    this.closeEvent.emit();
  }

  private checkAndInitializeStorage(): CoachmarkStorage {
    let coachmarkInfo: CoachmarkStorage;

    try {
      coachmarkInfo = JSON.parse(localStorage.getItem(this.LS_COUPON_COACHMARK)) as CoachmarkStorage;
    } catch (error) {
      coachmarkInfo = { value: [] };
    }

    if (!coachmarkInfo) {
      coachmarkInfo = {
        value: [
          {
            product: this.product,
            showCount: 0,
            lastShownAt: null
          }
        ]
      };
      localStorage.setItem(this.LS_COUPON_COACHMARK, JSON.stringify(coachmarkInfo));
    } else {
      const productIndex = coachmarkInfo.value.findIndex((product) => product.product === this.product);
      if (productIndex === -1) {
        coachmarkInfo.value.push({
          product: this.product,
          showCount: 0,
          lastShownAt: null
        });
        localStorage.setItem(this.LS_COUPON_COACHMARK, JSON.stringify(coachmarkInfo));
      }
    }

    return coachmarkInfo;
  }

  private init(): void {
    this.isCouponActive = this.cookieService.get(this.isActiveDiscountCookieName) === 'true';

    if (!this.isCouponActive) return;

    const coachmarkInfo = this.checkAndInitializeStorage();

    const coachmarkInfoByProduct = coachmarkInfo.value.find((item) => item.product === this.product);

    this.showTooltip = this.isCouponActive && coachmarkInfoByProduct.showCount < 1;

    if (this.showTooltip) {
      coachmarkInfoByProduct.showCount = 1;
      coachmarkInfoByProduct.lastShownAt = new Date().toISOString();
      localStorage.setItem(this.LS_COUPON_COACHMARK, JSON.stringify(coachmarkInfo));
    }
  }
}
